import type { Message } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { getInteractionModeExecutedFromMetadata } from './getInteractionModeExecutedFromMetadata';

export const getInteractionModeExecutedFromMessage = (
	message?: Pick<Message, 'message_metadata'> | null,
): string | undefined => getInteractionModeExecutedFromMetadata(message?.message_metadata);
